import Vue from 'vue';
import Vuex from 'vuex';
import * as actions from './actions';
import * as getters from './getters';
import * as types from './mutation-types';
import user from './modules/user';
import updates from './modules/updates';
import customers from './modules/customers';
import suppliers from './modules/suppliers';
import comments from './modules/comments';
import payments from './modules/payments';
import purchaseOrders from './modules/purchase-orders';
import purchaseOrder from './modules/purchase-order';
import receivables from './modules/receivables';
import receivable from './modules/receivable';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    menuToggled: false,
    isPo: false,
    isPayments: false,
    isReceivables: false,
    isPOFirstLoad: true,
    isPaymentsFirstLoad: true,
    isReceivablesFirstLoad: true,
    isZeenow: false,
  },
  actions,
  getters,
  mutations: {
    [types.TOGGLE_MENU](state, toggleMenu) {
      state.menuToggled = toggleMenu;
    },
    [types.SET_IS_ZEENOW](state, checkZeenow) {
      state.isZeenow = checkZeenow;
    },
    [types.SET_IS_PO](state, isPO) {
      state.isPo = isPO;
    },
    [types.SET_IS_PAYMENTS](state, isPayments) {
      state.isPayments = isPayments;
    },
    [types.SET_IS_RECEIVABLES](state, isReceivables) {
      state.isReceivables = isReceivables;
    },
    [types.SET_IS_PAYMENTS_FIRST_LOAD](state, isPaymentsFirstLoad) {
      state.isPaymentsFirstLoad = isPaymentsFirstLoad;
    },
    [types.SET_IS_RECEIVABLES_FIRST_LOAD](state, isReceivablesFirstLoad) {
      state.isReceivablesFirstLoad = isReceivablesFirstLoad;
    },
    [types.SET_IS_PO_FIRST_LOAD](state, isPOFirstLoad) {
      state.isPOFirstLoad = isPOFirstLoad;
    },
  },
  modules: {
    user,
    purchaseOrders,
    purchaseOrder,
    customers,
    payments,
    comments,
    suppliers,
    updates,
    receivables,
    receivable,
  },
});



// WEBPACK FOOTER //
// ./src/store/index.js